export default (message => {
  if (typeof window['CE_DECORATOR_STRICT_MODE'] !== 'undefined') {
    // eslint-disable-line
    console.warn(message); // eslint-disable-line
  }
});
